module.exports = __webpack_public_path__ + "img/user.64464733.svg";